import styled from 'styled-components';

import { Box } from '@sternum/styled-system';

export const Wrapper = styled(Box)`
  position: relative;
  max-width: 100%;
`;

export const HelperContainer = styled.div`
  position: absolute;
  white-space: nowrap;
  top: 0;
  left: 0;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  height: 0;
  overflow: hidden;
`;

export const Container = styled(Box)`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  > * {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const LeftRightMarkPlaceholder = styled.div`
  width: 0;
  height: 0;
  pointer-events: none;
`;
